import { NgStyle } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ReviewSelectedSolutionsStore } from './review-selected-solutions.store';

@Component({
    selector: 'app-review-selected-solutions',
    imports: [NgStyle, ProgressSpinnerModule],
    providers: [ReviewSelectedSolutionsStore],
    templateUrl: './review-selected-solutions.component.html',
    styleUrl: './review-selected-solutions.component.scss'
})
export class ReviewSelectedSolutionsComponent implements OnInit {
  readonly store = inject(ReviewSelectedSolutionsStore);

  @Input() diagnosisSessionId: string = '';

  ngOnInit(): void {
    this.store.loadSelectedSolutions(this.diagnosisSessionId);
  }
}
